import useSWR from 'swr';

import { FreeLeadsUsage } from 'models';

import { CompanyProfileService } from 'services/CompanyProfileService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

export const useFreeLeads = (companyId: string | undefined) => {
    const swr = useSWR<FreeLeadsUsage>(
        ...prepareConditionalSwrArgs({
            key: `/api/manufacturers/${companyId}/free-leads`,
            fetcher: () => CompanyProfileService.getFreeLeads(companyId!),
            condition: Boolean(companyId),
        }),
    );

    return { ...swr, freeLeads: swr.data ?? null };
};
